import { render } from "./AuxiliaryMessage.vue?vue&type=template&id=cf6c4056"
import script from "./AuxiliaryMessage.vue?vue&type=script&lang=js"
export * from "./AuxiliaryMessage.vue?vue&type=script&lang=js"

import "./AuxiliaryMessage.vue?vue&type=style&index=0&id=cf6c4056&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__